import { gql } from '@apollo/client';

const GET_INVOICES = gql`
  query GetInvoices($pageNumber: Int!, $limit: Int!) {
    invoices(pageNumber: $pageNumber, limit: $limit) {
      Invoices {
        Id
        OrgUnit
        InvoiceNumber
        PurchaseOrderNumber
        DueDate
        IsPastDue
        InvoiceTotal
        Status
        Description
      }
      TotalCount
      ViewPayInvoiceUrl
    }
  }
`;

export default GET_INVOICES;
